import React from "react";
import * as S from "./styles";

interface Props {
  message: string;
}

const Message: React.FC<Props> = (props) => {
  return (
    <S.Container>
      <S.Text>{props?.message}</S.Text>
    </S.Container>
  );
};

export default Message;
